let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6fRhy")).then(() => parcelRequire('cH7nJ'));